export default __webpack_public_path__ + "static/media/checkout-status.087461db.svg";